import scrollSpy from 'simple-scrollspy'
import jumpTo from 'jump.js'

const scrollspyOptions = {
    sectionClass: '.section',
    menuActiveTarget: '.navbar-scrollspy a',
    smoothScroll: true,
    offset: 100,
    smoothScrollBehavior: function (element) {
        jumpTo(element, {
            duration: 1000,
        })
    }
}

export default {
    props: {
        items: Array,
        placeholder: String,
        i18n: Object,
    },
    data() {
        return {
            groups: [
                {name: "A-D", letters: ["a", "b", "c", "d"]},
                {name: "E-H", letters: ["e", "f", "g", "h"]},
                {name: "I-L", letters: ["i", "j", "k", "l"]},
                {name: "M-P", letters: ["m", "n", "o", "p"]},
                {name: "Q-T", letters: ["q", "r", "s", "t"]},
                {name: "U-Z", letters: ["u", "v", "w", "x", "y", "z"]},
            ]
        }
    },
    methods: {
        getItemsByLetter(letter) {
            const tmpItems = [...this.items];

            return tmpItems.filter(x => x.letter.toLowerCase() === letter.toLowerCase());
        },
        getItemCountByLetter(letter) {
            return this.getItemsByLetter(letter).length;
        },
        getItemCountByLetters(letters) {
            return letters.reduce((accumulator, letter) => accumulator + this.getItemsByLetter(letter) <= 0, 0);
        },
        isGroupNotEmpty(letters) {
            return this.items.some(item => letters.indexOf(item.letter.toLowerCase()) >= 0);
        }
    },
    mounted() {
        scrollSpy(this.$refs.scrollspy, scrollspyOptions);
    },
    template: `
        <section id="results" class="py-2 py-lg-4 pb-xl-6 pb-xxl-8">
        <h2>{{ i18n.allBreeds }}</h2>
        <div class="row d-none d-lg-flex">
            <div class="col-lg-2">
                <nav id="navbar-vertical"
                     class="navbar navbar-vertical navbar-scrollspy flex-column align-items-start sticky-top pt-1 pt-md-2">
                    <nav ref="scrollspy" id="scrollspy"
                         class="nav nav-pills flex-lg-column justify-content-between justify-content-lg-start w-100 w-lg-auto">
                        <template v-for="({name, letters}, index) in groups">
                            <a :key="name" v-if="isGroupNotEmpty(letters)" class="nav-link"
                               :href="'#section-' + (index + 1)">
                                {{ name }}
                            </a>
                        </template>
                    </nav>
                </nav>
            </div>
            <div class="col-lg-10">
                <template v-for="({letters}, index) in groups">
                    <div
                        v-if="isGroupNotEmpty(letters)"
                        :id="'section-' + (index + 1)"
                        class="section pt-2"
                    >
                        <template v-for="letter in letters">
                            <template v-if="getItemCountByLetter(letter) > 0">
                                <h5>{{ letter.toUpperCase() }}</h5>
                                <ul class="list-breeds list-unstyled line-height-lg p-0 mb-2 mb-lg-3 d-grid grid-lg-2 grid-xl-3">
                                    <li class="mb-1 mb-lg-2 d-flex" v-for="item in getItemsByLetter(letter)"
                                        :key="item.name">
                                        <a :href="item.link">
                                            <img width="88" height="88" :src="item.image || placeholder"
                                                 class="img-fluid img-breed me-1" :alt="item.name"/>
                                        </a>
                                        <p className="m-0 pe-lg-3 pe-xl-4 pt-75 smaller fw-bolder line-height-md">
                                            <a :href="item.link">
                                                {{ item.name }}
                                            </a>
                                        </p>
                                    </li>
                                </ul>
                            </template>
                        </template>
                    </div>
                </template>
            </div>
        </div>
        <div class="accordion accordion-default mt-2 mt-lg-4 mb-5 d-lg-none" id="accordionBreeds">
            <template v-for="({letters, name}, index) in groups">
                <div v-if="isGroupNotEmpty(letters)" :id="'section-' + (index + 1)" class="accordion-item">
                    <h5 class="accordion-header" :id="'heading' + letters[0]">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                :data-bs-target="'#collapseBreed' + letters[0]" aria-expanded="true"
                                :aria-controls="'#collapseBreed' + letters[0]">
                            {{ name }}
                        </button>
                    </h5>
                    <div :id="'collapseBreed' + letters[0]" class="accordion-collapse collapse"
                         :aria-labelledby="'headingBreed' + letters[0]" data-bs-parent="#accordionBreeds">
                        <div class="accordion-body pt-0">
                            <div class="pt-2">
                                <template v-for="letter in letters">
                                    <template v-if="getItemCountByLetter(letter) > 0">
                                        <h5>{{ letter.toUpperCase() }}</h5>
                                        <ul class="list-breeds list-unstyled line-height-lg p-0 mb-2 mb-lg-3 d-grid grid-lg-2 grid-xl-3">
                                            <li class="mb-1 mb-lg-2 d-flex" v-for="item in getItemsByLetter(letter)"
                                                :key="item.name">
                                                <a :href="item.link">
                                                    <img width="88" height="88" :src="item.image || placeholder"
                                                         class="img-fluid img-breed me-1" :alt="item.name"/>
                                                </a>
                                                <p class="m-0 pe-lg-2 pt-75 smaller fw-bolder line-height-md">
                                                    <a :href="item.link">
                                                        {{ item.name }}
                                                    </a>
                                                </p>
                                            </li>
                                        </ul>
                                    </template>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        </section>
    `
}
